(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-promise-slider"] && !Shopify.designMode) return;
  try {
    
  class PromiseSlider {
    constructor(section) {
      this.section = section;
      this.buttons = this.section.querySelectorAll('.promise-button');
      this.contentSlides = this.section.querySelectorAll('.content-slider__slide');
      this.videoSlides = this.section.querySelectorAll('.video-slider__slide');
      this.videos = this.section.querySelectorAll('.promise-video');
      
      this.enableAutoplay = this.section.dataset.enableAutoplay === 'true';
      this.autoplayDelay = parseInt(this.section.dataset.autoplayDelay, 10) * 1000;
      this.autoplayInterval = null;
      this.currentIndex = -1; // Start at -1 to ensure first slide transition works

      this.init();
    }

    init() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          // When user clicks, stop the autoplay
          if (this.enableAutoplay) {
            clearInterval(this.autoplayInterval);
          }
          
          const index = parseInt(button.dataset.index, 10);
          this.goToSlide(index);

          // Restart autoplay after manual click
          if (this.enableAutoplay) {
            this.startAutoplay();
          }
        });
      });

      // Initialize with the first slide
      this.goToSlide(0);

      // Start autoplay if enabled
      if (this.enableAutoplay) {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      clearInterval(this.autoplayInterval); // Clear any existing interval
      this.autoplayInterval = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.buttons.length;
        this.goToSlide(nextIndex);
      }, this.autoplayDelay);
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;

      // Update buttons
      this.buttons.forEach((button, i) => {
        button.classList.toggle('is-active', i === index);
      });

      // Update content slides
      this.contentSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      // Update video slides and handle video playback
      this.videoSlides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      this.videos.forEach((video, i) => {
        if (i === index) {
          video.currentTime = 0;
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.warn("Video autoplay prevented for slide:", index, error);
            });
          }
        } else {
          video.pause();
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.promise-section-wrapper');
    sections.forEach(section => {
      new PromiseSlider(section);
    });
  });

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.promise-section-wrapper');
    if (section) {
      new PromiseSlider(section);
    }
  });

  document.addEventListener('shopify:section:reorder', (event) => {
      const section = event.target.querySelector('.promise-section-wrapper');
      if (section) {
          new PromiseSlider(section);
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const whenVisible = (element, callback) => {
      const observer = new IntersectionObserver((entries, obs) => {
        if (entries[0].isIntersecting && entries[0].boundingClientRect.width > 0) {
          callback();
          obs.disconnect();
        }
      });
      observer.observe(element);
    };

    class TestimonialSlider {
      constructor(container) {
        this.container = container;
        this.track = this.container.querySelector('.js-slider-track');
        if (!this.track) return;
        
        this.slides = Array.from(this.track.children);
        if (this.slides.length === 0) return;

        this.prevButton = this.container.querySelector('.js-slider-prev');
        this.nextButton = this.container.querySelector('.js-slider-next');
        this.pagination = this.container.querySelector('.js-slider-pagination');
        
        this.settings = {
          autoplay: this.container.dataset.autoplay === 'true',
          autoplaySpeed: parseInt(this.container.dataset.autoplaySpeed, 10) || 5000,
          charLimit: parseInt(this.container.dataset.charLimit, 10),
          readMoreText: this.container.dataset.readMore
        };
        
        whenVisible(this.container, () => this.init());
      }
      
      init() {
        this.currentIndex = 0;
        this.autoplayInterval = null;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isDragging = false;
        
        this.createPagination();
        this.bindEvents();
        this.startAutoplay();
        this.handleTruncateText();
        this.observeSlides();
        this.updateSlider();
      }

      getSlidesPerView() {
        const slidesInView = getComputedStyle(this.container.parentElement).getPropertyValue('--slides-in-view');
        return parseFloat(slidesInView) || 1;
      }

      getTotalPages() {
        const slidesPerView = this.getSlidesPerView();
        if (this.slides.length <= slidesPerView) {
          return 1;
        }
        return this.slides.length - Math.floor(slidesPerView) + 1;
      }
      
      updateSlider() {
        if (this.slides.length === 0) return;
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const offset = -this.currentIndex * slideWidth;
        this.track.style.transform = `translateX(${offset}px)`;
        if (this.pagination) this.updatePagination();
      }
      
      goToSlide(index) {
        const totalPages = this.getTotalPages();
        if (totalPages <= 1) {
          this.currentIndex = 0;
        } else if (index < 0) {
          this.currentIndex = totalPages - 1;
        } else if (index >= totalPages) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = index;
        }
        this.updateSlider();
      }
      
      createPagination() {
        if (!this.pagination) return;
        this.pagination.innerHTML = '';
        const totalPages = this.getTotalPages();
        if (totalPages <= 1) return;

        const dotUniqueClass = this.pagination.parentElement.className.split(' ')[0] + '__dot';
        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement('button');
          dot.classList.add(dotUniqueClass);
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => {
            this.goToSlide(i);
            this.resetAutoplay();
          });
          this.pagination.appendChild(dot);
        }
        this.updatePagination();
      }
      
      updatePagination() {
        if (!this.pagination) return;
        const activeClass = this.pagination.parentElement.className.split(' ')[0] + '__dot--active';
        const dots = this.pagination.querySelectorAll('button');
        dots.forEach((dot, index) => {
          dot.classList.toggle(activeClass, index === this.currentIndex);
        });
      }

      startAutoplay() {
        if (!this.settings.autoplay || this.getTotalPages() <= 1) return;
        this.autoplayInterval = setInterval(() => {
          this.goToSlide(this.currentIndex + 1);
        }, this.settings.autoplaySpeed);
      }

      stopAutoplay() {
        clearInterval(this.autoplayInterval);
      }
      
      resetAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      handleTruncateText() {
        if (!this.settings.charLimit || this.settings.charLimit <= 0) return;
        const readMoreClass = this.container.className.split(' ')[0] + '__read-more';
        this.slides.forEach(slide => {
          const textElement = slide.querySelector('.js-testimonial-text');
          if (!textElement) return;
          if (!textElement.dataset.originalText) {
            textElement.dataset.originalText = textElement.innerHTML;
          }
          const originalHTML = textElement.dataset.originalText;
          const textContent = textElement.textContent.trim();
          if (textContent.length > this.settings.charLimit) {
            const truncatedText = textContent.substring(0, this.settings.charLimit);
            textElement.innerHTML = `<p>${truncatedText}... <span class="${readMoreClass}">${this.settings.readMoreText}</span></p>`;
            const readMoreLink = textElement.querySelector(`.${readMoreClass}`);
            readMoreLink.addEventListener('click', (e) => {
              e.preventDefault();
              textElement.innerHTML = originalHTML;
            }, { once: true });
          }
        });
      }

      observeSlides() {
        const visibleClass = this.container.className.split(' ')[0] + '__slide' + '.is-visible';
        const slideClass = this.container.className.split(' ')[0] + '__slide';
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            }
          });
        }, { threshold: 0.1 });
        this.slides.forEach(slide => observer.observe(slide));
      }

      bindEvents() {
        if (this.nextButton) this.nextButton.addEventListener('click', () => { this.goToSlide(this.currentIndex + 1); this.resetAutoplay(); });
        if (this.prevButton) this.prevButton.addEventListener('click', () => { this.goToSlide(this.currentIndex - 1); this.resetAutoplay(); });
        
        this.container.addEventListener('mouseenter', () => this.stopAutoplay());
        this.container.addEventListener('mouseleave', () => this.startAutoplay());
        
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.createPagination();
            this.updateSlider();
          }, 250);
        });

        this.track.addEventListener('touchstart', (e) => this.touchStart(e), { passive: true });
        this.track.addEventListener('touchmove', (e) => this.touchMove(e));
        this.track.addEventListener('touchend', () => this.touchEnd());
        this.track.addEventListener('mousedown', (e) => this.touchStart(e));
        this.track.addEventListener('mousemove', (e) => this.touchMove(e));
        this.track.addEventListener('mouseup', () => this.touchEnd());
        this.track.addEventListener('mouseleave', () => { if (this.isDragging) this.touchEnd(); });
      }

      touchStart(e) {
        if (this.getTotalPages() <= 1) return;
        this.isDragging = true;
        this.touchStartX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        this.track.style.transition = 'none';
        this.stopAutoplay();
      }
      
      touchMove(e) {
        if (!this.isDragging) return;
        if(e.cancelable) e.preventDefault();
        const currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        this.touchEndX = currentX;
        const diff = this.touchEndX - this.touchStartX;
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const offset = -this.currentIndex * slideWidth + diff;
        this.track.style.transform = `translateX(${offset}px)`;
      }
      
      touchEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.style.transition = 'transform 500ms ease-in-out';
        const diff = this.touchEndX - this.touchStartX;
        if (Math.abs(diff) > 50) {
          if (diff < 0) this.goToSlide(this.currentIndex + 1);
          else this.goToSlide(this.currentIndex - 1);
        } else {
          this.updateSlider();
        }
        this.startAutoplay();
      }
    }
    
    const initSliders = () => {
      document.querySelectorAll('.js-slider-wrapper').forEach(slider => {
        if (!slider.classList.contains('initialized')) {
          new TestimonialSlider(slider);
          slider.classList.add('initialized');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliders);
    } else {
      initSliders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.js-slider-wrapper');
      if (section && !section.classList.contains('initialized')) {
        new TestimonialSlider(section);
        section.classList.add('initialized');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
